import React from 'react';
import { motion } from 'framer-motion';
export function Results() {
  return <section className="results" data-id="element-132">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-133">
        <span className="section-tag" data-id="element-134">Después del Workshop</span>
        <h2 data-id="element-135">Lo que vas a lograr</h2>

        <div className="results-grid" data-id="element-136">
          <div className="result-card" data-id="element-137">
            <span className="r-icon" data-id="element-138">🌐</span>
            <h4 data-id="element-139">Tu página publicada en internet</h4>
            <p data-id="element-140">
              Con tu dominio, profesional, lista para que cualquier cliente la
              vea.
            </p>
          </div>
          <div className="result-card" data-id="element-141">
            <span className="r-icon" data-id="element-142">🔓</span>
            <h4 data-id="element-143">Independencia total</h4>
            <p data-id="element-144">
              La editas, la cambias y la actualizas cuando quieras. Sin pedirle
              permiso a nadie.
            </p>
          </div>
          <div className="result-card" data-id="element-145">
            <span className="r-icon" data-id="element-146">💰</span>
            <h4 data-id="element-147">Te ahorras miles de dólares</h4>
            <p data-id="element-148">
              Lo que un diseñador te cobra $3,000+ tú lo aprendes a hacer por
              $37 y una tarde de tu tiempo.
            </p>
          </div>
          <div className="result-card" data-id="element-149">
            <span className="r-icon" data-id="element-150">♾️</span>
            <h4 data-id="element-151">Una habilidad para siempre</h4>
            <p data-id="element-152">
              Puedes crear más páginas para otros proyectos, clientes, o ideas
              futuras.
            </p>
          </div>
          <div className="result-card span-2" data-id="element-153">
            <span className="r-icon" data-id="element-154">⚡</span>
            <h4 data-id="element-155">Dejas de perder clientes por no tener presencia online</h4>
            <p data-id="element-156">
              Cuando alguien busque tu negocio, te va a encontrar. Y lo que va a
              ver le va a dar confianza para comprarte.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}